import Utilities from "../../foundation/Utility";
import Person from "../../types/core/Person";

class User extends Person {
    id: number;
    personID: number;
    username: string;
    password: string;
    teacherCode: string;
    studentCode: string;
    impersonator: string;
    profilePicture: string;
    apps: string[];
    groups: string[];
    roles: string[];
    schools: number[];
    fido2Credentials: string[];
    workTitle: string;
    tdsSessionId: string;
    encryptionKey: string;
    elevioUserEmail: string;
    elevioUserHash: string;
    elevioUserRegisteredAt: number;
    active: boolean;
    createdOn: Date;
    editedOn: Date;
    createdBy: number;
    editedBy: number;

    generatePassword: boolean;
    emailPassword: boolean;

    get hasFido2(): boolean {
        return this.fido2Credentials && this.fido2Credentials.length > 0;
    }

    constructor(data?: Partial<User>) {
        super(data);

        Object.assign(this, data);
    }

    get type(): string | undefined {
        if (this.teacherCode) return "Teacher";
        if (this.studentCode) return "Student";
        return "User";
    }
    set type(_: string | undefined) {}

    get code(): string | undefined {
        const result = [];
        if (this.teacherCode) result.push(this.teacherCode);
        if (this.studentCode) result.push(this.studentCode);
        return result.join(", ") || undefined;
    }
    set code(_: string | undefined) {}

    get isStudent(): boolean | undefined {
        return Utilities.notNull(this.studentCode);
    }
    set isStudent(value: boolean | undefined) {
        this.studentCode = value ? this.studentCode ?? "" : undefined;
    }

    get isTeacher(): boolean | undefined {
        return Utilities.notNull(this.teacherCode);
    }
    set isTeacher(value: boolean | undefined) {
        this.teacherCode = value ? this.teacherCode ?? "" : undefined;
    }
}

export default User;
